module.exports = __webpack_public_path__ + "static/media/caros-light.66125da4.woff";